import React from "react";
import { CloudUpload, DriveFileRenameOutline } from "@mui/icons-material";
import { Box } from "@mui/material";

import { StackedNavigationButton, useStackedNavigationContext } from "fond/widgets";
import StackedNavigationHeader from "fond/widgets/StackedNavigation/StackedNavigationHeader";

interface LayerPanelProps {
  title: string;
  layerKey: string;
  testIdPrefix?: string;
}

const LayerPanel: React.FC<LayerPanelProps> = ({ title, layerKey, testIdPrefix }) => {
  const { open, clear } = useStackedNavigationContext();
  const testPrefix = testIdPrefix || layerKey;

  const handleOnDrawButtonClick = () => {
    open(`${layerKey}-draw`);
  };

  const handleOnUploadPolygon = () => {
    open(`${layerKey}-upload`);
  };

  const onBack = () => {
    clear();
  };

  return (
    <Box>
      <StackedNavigationHeader title={title} onBackButtonClick={onBack} />
      <StackedNavigationButton
        data-testid={`draw-${testPrefix}-button`}
        icon={<DriveFileRenameOutline />}
        title="Draw"
        subtitle="Add and edit data on the map"
        onClick={handleOnDrawButtonClick}
      />
      <StackedNavigationButton
        data-testid={`upload-${testPrefix}-button`}
        icon={<CloudUpload />}
        title="Upload"
        subtitle="Use my data"
        onClick={handleOnUploadPolygon}
      />
    </Box>
  );
};

export default LayerPanel;
